import React from "react";
import { withRouter } from "../../utils/withRouter";
import { connect } from "react-redux";
import { updateVideo } from "../../Redux/Actions/videos";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { CirclePicker } from "react-color";
import "./style.css";

interface IProps {
  updateVideo: (video: any) => void;
  isVideoUpdating: boolean;
  loading: boolean;
  match: any;
  video: any;
}

class Design extends React.Component<IProps> {
  state = { description: "", typingTimeout: 0, descriptionLoaded: false };

  componentDidUpdate() {
    if (this.props.video && this.props.video.description && !this.state.descriptionLoaded) {
      this.setState({ description: this.props.video.description, descriptionLoaded: true });
    }
  }

  render() {
    return (
      <div className="vtDesignPanel">
        <div className="vtDesignRow">
          <label className="vtDesignLabel">Player</label>
          <div className="vtDesignField">
            <FormControlLabel
              control={<Checkbox name="displayLogo" color="default" />}
              label="Display company logo on video player"
            />
          </div>
        </div>

        <div className="vtDesignRow">
          <label className="vtDesignLabel">Logo Position</label>
          <div className="vtDesignField">
            <select className="vtDesignSelect">
              <option value="top-left">Top Left</option>
              <option value="top-right">Top Right</option>
              <option value="bottom-left">Bottom Left</option>
              <option value="bottom-right">Bottom Right</option>
            </select>
          </div>
        </div>

        <div className="vtDesignRow">
          <label className="vtDesignLabel">Player Color</label>
          <div className="vtDesignField">
            <div className="roundWrapper">
              <CirclePicker />
            </div>
          </div>
        </div>

        <div className="vtDesignRow">
          <label className="vtDesignLabel">Background</label>
          <div className="vtDesignField">
            <p style={{ fontSize: 13, color: "#667085", margin: "0 0 8px" }}>
              Add a custom background image to your video page.
            </p>
            <input type="text" className="vtDesignTextInput" placeholder="Enter image URL" />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: any) => ({
  loading: state.video.loading,
  isVideoUpdating: state.video.isVideoUpdating,
  video: state.video.singleVideo,
});
const mapDispatchToProps = (dispatch: any) => ({
  updateVideo: (video: any) => dispatch(updateVideo(video)),
});
export default withRouter<any, any>(connect(mapStateToProps, mapDispatchToProps)(Design));
